// Широкий поиск гостя по имени / email / телефону для чек-ина.
// Цель: один инпут, максимально прощающий ввод.
//   Телефон: +972584053547 ↔ 0584053547 ↔ 584053547 ↔ частичный ввод.
//   Email:   регистронезависимо, по подстроке.
//   Имя:     регистронезависимо, токены в любом порядке («Кац Павел» ↔ «Павел Кац»).

import type { CheckinRow } from '../api.js';

export function digitsOnly(s: string): string {
  return (s || '').replace(/\D+/g, '');
}

/** Телефонный матч: подстрока по цифрам ИЛИ совпадение значащего «хвоста» (9 цифр). */
export function phoneMatches(stored: string, query: string): boolean {
  const s = digitsOnly(stored);
  const q = digitsOnly(query);
  if (q.length < 3 || !s) return false;
  if (s.includes(q)) return true; // частичный ввод (префикс/суффикс/середина)
  const st = s.slice(-9);
  const qt = q.slice(-9);
  return st.length >= 7 && st === qt; // варианты +972/0/без префикса
}

function nameMatches(name: string, query: string): boolean {
  const n = (name || '').toLowerCase();
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return false;
  return tokens.every((t) => n.includes(t));
}

function emailMatches(email: string, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return false;
  return (email || '').toLowerCase().includes(q);
}

/** true, если строка подходит под поисковый запрос (любой из критериев). */
export function rowMatches(row: CheckinRow, rawQuery: string): boolean {
  const query = rawQuery.trim();
  if (!query) return true;
  const hasLetters = /[^\d\s+().-]/.test(query);
  if (emailMatches(row.email, query)) return true;
  if (phoneMatches(row.phone, query)) return true;
  if (hasLetters && nameMatches(row.name, query)) return true;
  // запасной матч по номеру билета
  if ((row.ticketNumber || '').toLowerCase().includes(query.toLowerCase())) return true;
  return false;
}

export function filterRows(rows: CheckinRow[], query: string): CheckinRow[] {
  const q = query.trim();
  if (!q) return rows;
  return rows.filter((r) => rowMatches(r, q));
}
